import { RequestWebApi, validateRequestErrorStatus } from "./Requests";

const controller = "FornecedorLead";
export const Listar = (fornecedor) =>
  RequestWebApi.get(`/${controller}/Listar`, {
    params: { ...fornecedor },
  })
    .then(function (response) {
      const { resultData, success } = response.data;
      const fornecedoresLead = resultData;
      return { success, fornecedoresLead };
    })
    .catch(function (error) {
      validateRequestErrorStatus(error.response.status);
      return { fornecedoresLead: [] };
    });

export const Detalhes = (fornecedorLeadId) =>
  RequestWebApi.get(`/${controller}/Detalhes`, {
    params: { fornecedorLeadId: fornecedorLeadId },
  })
    .then(function (response) {
      const { resultData, success } = response.data;
      const fornecedorLead = resultData;
      return { success, fornecedorLead };
    })
    .catch(function (error) {
      validateRequestErrorStatus(error.response.status);
      const { success, message, errors } = error.response.data;
      return { success, message, errors, fornecedorLead: {} };
    });

export const Incluir = (fornecedorLead) =>
  RequestWebApi.post(`/${controller}/Incluir`, fornecedorLead)
    .then(function (response) {
      const { resultData, success } = response.data;
      const novoGrupoUsuario = resultData;
      return { success, novoGrupoUsuario };
    })
    .catch(function (error) {
      validateRequestErrorStatus(error.response.status);
      const { success, message, errors } = error.response.data;
      return { success, message, errors };
    });

export const Atualizar = (fornecedorLead) =>
  RequestWebApi.put(`/${controller}/Atualizar`, fornecedorLead)
    .then(function (response) {
      const { success } = response.data;
      return { success };
    })
    .catch(function (error) {
      validateRequestErrorStatus(error.response.status);
      const { success, message, errors } = error.response.data;
      return { success, message, errors };
    });

export const Remover = (fornecedorLeadId) =>
  RequestWebApi.delete(`/${controller}/Remover`, {
    params: { fornecedorLeadId: fornecedorLeadId },
  })
    .then(function (response) {
      const { success } = response.data;
      return { success };
    })
    .catch(function (error) {
      validateRequestErrorStatus(error.response.status);
      const { success, message, errors } = error.response.data;
      return { success, message, errors };
    });
